<div
  class="bg-cover bg-center bg-fixed min-h-screen flex flex-col items-center justify-center"
  style="background-image: url('https://estcdndev.blob.core.windows.net/document/Loginpage/img/loginbg_img.jpg');"
>
  <div class="flex flex-col items-center w-full">
    <!-- Logo -->
    <img
      src="https://estcdndev.blob.core.windows.net/document/Loginpage/img/estlogow.png"
      alt="Logo"
      class="w-72 mb-8 max-sm:w-60"
    />

    <!-- Login Form -->
    <form
      [formGroup]="reactiveForm"
      (ngSubmit)="onSubmit()"
      class="bg-white rounded-lg shadow-lg p-10 w-[500px] max-sm:w-[350px]"
    >
      <p class="text-3xl text-[#5A2C81] font-semibold text-center mb-8">Login</p>

      <!-- Email Field -->
      <div class="relative mb-6">
        <input
          type="email"
          id="email"
          formControlName="user_name"
          placeholder=" "
          required
          class="peer w-full border border-gray-400 rounded px-3 py-3 focus:outline-none focus:border-black"
        />
        <label
          for="email"
          class="absolute left-3 top-3 text-gray-400 bg-white px-1 transition-all duration-200
                 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-gray-400
                 peer-placeholder-shown:text-base
                 peer-focus:-top-2 peer-focus:text-sm peer-focus:text-[#707070]
                 peer-valid:-top-2 peer-valid:text-sm peer-valid:text-[#707070]"
        >
          Enter Email Address
        </label>
        <span
          *ngIf="reactiveForm.get('user_name')?.invalid && reactiveForm.get('user_name')?.touched"
          class="text-red-600 text-sm font-semibold mt-1 block"
        >
          Email is required
        </span>
      </div>

      <!-- Password Field -->
      <div class="relative mb-6">
        <input
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          formControlName="password"
          placeholder=" "
          required
          class="peer w-full border border-gray-400 rounded px-3 py-3 pr-10 focus:outline-none focus:border-black"
        />
        <label
          for="password"
          class="absolute left-3 top-3 text-gray-400 bg-white px-1 transition-all duration-200
                 peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-gray-400
                 peer-placeholder-shown:text-base
                 peer-focus:-top-2 peer-focus:text-sm peer-focus:text-[#707070]
                 peer-valid:-top-2 peer-valid:text-sm peer-valid:text-[#707070]"
        >
          Enter Password
        </label>

        <!-- Eye Icon -->
        <button
          type="button"
          class="absolute right-3 top-1/2 transform -translate-y-1/2"
          (click)="togglePasswordVisibility()"
        >
          <!-- Eye Slashed (hidden password) -->
          <svg
            *ngIf="!showPassword"
            class="h-4 text-gray-700"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
          >
            <path
              fill="currentColor"
              d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
            />
          </svg>

          <!-- Eye Open (shown password) -->
          <svg
            *ngIf="showPassword"
            class="h-4 text-gray-700"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
          >
            <path
              fill="currentColor"
              d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
            />
          </svg>
        </button>

        <span
          *ngIf="reactiveForm.get('password')?.invalid && reactiveForm.get('password')?.touched"
          class="text-red-600 text-sm font-semibold mt-1 block"
        >
          Password is required
        </span>
      </div>

      <!-- Remember Me + Forget Password -->
      <div class="flex justify-between items-center mb-6">
        <label class="flex items-center text-gray-600 cursor-pointer">
          <input id="remember" type="checkbox" class="mr-2 cursor-pointer" />
          Remember Me
        </label>
        <a href="#" class="text-[#592C81] hover:underline">Forget Password?</a>
      </div>

      <!-- Submit Button -->
      <div class="flex justify-center">
        <button
          type="submit"
          [disabled]="isLoading"
          class="bg-[#5A2C81] text-white rounded-md py-3 px-8 text-lg w-1/2 min-w-[140px] disabled:opacity-50 cursor-pointer"
        >
          {{ isLoading ? 'Logging in...' : 'Login' }}
        </button>
      </div>

      <!-- Error Message -->
      <p *ngIf="errorMessage" class="text-center text-red-600 mt-4 font-semibold">
        {{ errorMessage }}
      </p>
    </form>
  </div>
</div>
<!-- ✅ Toast --> 
<div
  class="fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-md bg-green-600 px-4 py-3 text-white shadow-lg transition-all duration-300"
  [ngClass]="{ 'translate-y-0 opacity-100': showToast, 'translate-y-20 opacity-0': !showToast }"> <span
    class="material-symbols-outlined">check_circle</span>
  <p class="text-sm font-semibold">{{ toastMessage }}</p>
</div>